import { render, staticRenderFns } from "./approveRoleClearRequest.vue?vue&type=template&id=c12e3d88&"
import script from "./approveRoleClearRequest.vue?vue&type=script&lang=js&"
export * from "./approveRoleClearRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c12e3d88')) {
      api.createRecord('c12e3d88', component.options)
    } else {
      api.reload('c12e3d88', component.options)
    }
    module.hot.accept("./approveRoleClearRequest.vue?vue&type=template&id=c12e3d88&", function () {
      api.rerender('c12e3d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/components/approveRoleClearRequest.vue"
export default component.exports